import React from 'react';
import hiaeLogo from '~/assets/images/logo.svg';
import careplusLogo from '~/assets/images/careplus-logo-outline.png';
import { isCareplus } from '~/utils/constants/isCareplus';

export const LogoImage = () => {
  const logoProps = {
    src: isCareplus ? careplusLogo : hiaeLogo,
    alt: isCareplus ? 'Careplus' : 'HIAE',
  };
  return <img src={logoProps.src} alt={logoProps.alt} width={168} />;
};
